import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

const loadingDotsVariants = cva('inline-flex items-center', {
  variants: {
    size: {
      sm: 'gap-0.5',
      md: 'gap-1',
      lg: 'gap-1.5',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

const dotSizeClasses = {
  sm: 'size-1',
  md: 'size-[0.3125rem]',
  lg: 'size-1.5',
} satisfies Record<'sm' | 'md' | 'lg', string>

const DOT_DELAYS_S = [0, 0.16, 0.32]

function LoadingDots({
  className,
  size = 'md',
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof loadingDotsVariants>) {
  const resolvedSize = size ?? 'md'
  return (
    <span
      data-slot='loading-dots'
      aria-hidden='true'
      className={cn(loadingDotsVariants({ size }), className)}
      {...props}>
      {DOT_DELAYS_S.map((delay) => (
        <span
          key={delay}
          className={cn(
            'animate-loading-dots-bounce shrink-0 rounded-full bg-current motion-reduce:animate-none motion-reduce:opacity-100',
            dotSizeClasses[resolvedSize]
          )}
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
    </span>
  )
}

export { LoadingDots, loadingDotsVariants }
